import { useEffect, useState } from "react";
import { Navbar } from "@/components/site/Navbar";
import { Footer } from "@/components/site/Footer";
import { API } from "@/lib/api";
import axios from "axios";
import { Loader2, ArrowLeft } from "lucide-react";

const TITLES = {
  "privacy-policy": "Privacy Policy",
  "cookie-policy": "Cookie Policy",
  "eula": "Termini e Condizioni",
  "privacy-candidature": "Privacy Candidature",
};

// Renders the simple markdown returned by the ZERAMI legal endpoints
// (# = page title, ## = section, • / - = list item, else paragraph).
function renderMarkdown(text) {
  const nodes = [];
  let list = [];
  const flush = (key) => {
    if (list.length) {
      nodes.push(
        <ul key={`ul-${key}`} className="my-3 list-disc space-y-1.5 pl-6 text-stone">
          {list.map((li, i) => (
            <li key={i}>{li}</li>
          ))}
        </ul>
      );
      list = [];
    }
  };
  (text || "").split("\n").forEach((raw, idx) => {
    const t = raw.trim();
    if (!t) {
      flush(idx);
      return;
    }
    if (t.startsWith("## ")) {
      flush(idx);
      nodes.push(
        <h2 key={idx} className="mt-8 font-heading text-xl font-extrabold text-navy">
          {t.slice(3)}
        </h2>
      );
    } else if (t.startsWith("# ")) {
      flush(idx);
      nodes.push(
        <h1 key={idx} className="font-heading text-3xl font-extrabold tracking-tight text-navy">
          {t.slice(2)}
        </h1>
      );
    } else if (t.startsWith("•") || t.startsWith("- ")) {
      list.push(t.replace(/^([•]|-)\s*/, ""));
    } else {
      flush(idx);
      nodes.push(
        <p key={idx} className="mt-3 text-sm leading-relaxed text-stone">
          {t}
        </p>
      );
    }
  });
  flush("end");
  return nodes;
}

export default function LegalPage({ doc }) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;
    setLoading(true);
    axios
      .get(`${API}/legal/${doc}`)
      .then((r) => {
        if (active) setData(r.data);
      })
      .catch(() => {
        if (active) setData({ text: "" });
      })
      .finally(() => active && setLoading(false));
    return () => {
      active = false;
    };
  }, [doc]);

  return (
    <div className="relative min-h-screen bg-white">
      <Navbar />
      <main className="mx-auto max-w-3xl px-5 pb-24 pt-28 lg:pt-32">
        <a href="/" className="inline-flex items-center gap-2 text-sm font-semibold text-blue transition-colors hover:text-navy" data-testid="legal-back">
          <ArrowLeft className="h-4 w-4" /> Torna alla home
        </a>
        <div className="mt-6" data-testid={`legal-${doc}`}>
          {loading ? (
            <div className="flex items-center gap-3 py-20 text-stone">
              <Loader2 className="h-5 w-5 animate-spin" /> Caricamento…
            </div>
          ) : data && data.text ? (
            <>
              {renderMarkdown(data.text)}
              {data.updated_at ? (
                <p className="mt-10 border-t border-line pt-4 text-xs text-stone">
                  Ultimo aggiornamento: {String(data.updated_at)}
                </p>
              ) : null}
            </>
          ) : (
            <>
              <h1 className="font-heading text-3xl font-extrabold text-navy">{TITLES[doc] || "Documento"}</h1>
              <p className="mt-4 text-sm text-stone">Documento non disponibile al momento.</p>
            </>
          )}
        </div>
      </main>
      <Footer />
    </div>
  );
}
